import { ApiError } from "@altek/ui/lib/problem";
import { apiErrorMessage } from "@/lib/api/error-messages";

/**
 * GİRİŞ AKIŞLARININ HATA CÜMLESİ — ne zaman yeniden denenebileceğini söyler (9 Ekim 2026, 5. tur).
 *
 * Giriş, parola sıfırlama, davet ve yeniden doğrulama ortak sözlüğü (`apiErrorMessage`) kullanıyor;
 * iki kodda o sözlük kişiyi yanlış yere gönderiyordu:
 *
 * - `USER_LOCKED`: «Hesabınız kilitli. Yöneticinizle görüşün.» Oysa girişteki kilit sunucuda
 *   KENDİLİĞİNDEN AÇILAN bir sayaç (`altek-erp-backend/src/infra/lockout.ts`: 5 hatalı parola;
 *   sayaç son hatalı denemeden 15 dakika sonra düşüyor, kilitliyken parola hiç denenmediği için
 *   süre uzamıyor; tamamlanan bir parola sıfırlaması da kilidi kaldırıyor). Kişi yöneticisini
 *   arıyordu — beklemek ya da parolasını sıfırlamak yeterdi. «En geç 15 dakika» her an doğru:
 *   kalan süre hiçbir zaman pencereyi aşmıyor.
 * - `RATE_LIMITED`: kit süreyi saniyeyle söylüyor; giriş uçlarının penceresi 5–15 dakika ve
 *   «840 saniye sonra» okunmuyor. Bir dakikadan uzunu dakikaya yuvarlanıyor (yukarı — erken
 *   gelen kişi yine reddedilir).
 *
 * BİLİNEN SINIR: `users.status = LOCKED` da `USER_LOCKED` döndürüyor ve o kilit kendiliğinden
 * açılmaz. Hiçbir kod yolu o durumu yazmıyor (yalnız elle düzenlenmiş satır,
 * `account-flows.md` › Login lockout); sunucu iki durumu ayırana ya da kalan süreyi
 * (`retryAfterSeconds`) gönderene kadar cümle sayacınkini söylüyor.
 */
export const LOCKOUT_WINDOW_MINUTES = 15;

export const AUTH_FAILURE_MESSAGES = {
  locked: `Çok sayıda hatalı deneme yapıldı; giriş geçici olarak durduruldu. En geç ${LOCKOUT_WINDOW_MINUTES} dakika sonra tekrar deneyin ya da parolanızı sıfırlayın.`,
} as const;

/** «45 saniye», «5 dakika» — bir dakikanın altı saniyeyle, üstü yukarı yuvarlanmış dakikayla. */
export function waitPhrase(seconds: number): string {
  const whole = Math.max(1, Math.ceil(seconds));
  return whole < 60 ? `${whole} saniye` : `${Math.ceil(whole / 60)} dakika`;
}

function retryAfterOf(error: ApiError): number | null {
  const value = error.details?.retryAfterSeconds;
  return typeof value === "number" && Number.isFinite(value) && value > 0 ? value : null;
}

/** Giriş akışı ekranlarının tek hata cümlesi; geri kalan her kod ortak sözlükten. */
export function authFailureMessage(error: unknown): string {
  if (error instanceof ApiError) {
    if (error.code === "USER_LOCKED") return AUTH_FAILURE_MESSAGES.locked;
    if (error.code === "RATE_LIMITED") {
      const seconds = retryAfterOf(error);
      if (seconds !== null) {
        return `Çok fazla deneme yapıldı. ${waitPhrase(seconds)} sonra tekrar deneyin.`;
      }
    }
  }
  return apiErrorMessage(error);
}
